export function UmlautErsetzung(value) {
    return value.replace(/Ä/g, 'AE').replace(/Ö/g, 'OE').replace(/Ü/g, 'UE').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
}
// wandelt ein Datum der Art tt.mm.jjjj in eins der Art jjjj-mm-tt um
export function DatumToReverse(datum) {
    var ret = "";
    // umkehren, wenn Datum richtige Laenge hat und Punkte an richtiger Stelle (Datumscheck), tt.mm.jjjj
    if ((datum.length === 10) && (datum[2] === ".") && (datum[5] === ".")) {
        ret = datum.substr(6, 4) + "-" + datum.substr(3, 2) + "-" + datum.substr(0, 2);
    }
    // nicht umkehren, sondern Original zurueckgeben, falls datum bereits reverse ist
    if ((datum.length === 10) && (datum[4] === "-") && (datum[7] === "-")) {
        ret = datum;
    }
    return ret;
}
// wandelt ein Datum der Art jjjj-mm-tt in eins der Art tt.mm.jjjj um
export function DatumToNormal(datum) {
    var ret = "";
    // umkehren, wenn Datum richtige Laenge hat und Minusse an richtiger Stelle (Datumscheck), jjjj-mm-tt
    if ((datum.length === 10) && (datum[4] === "-") && (datum[7] === "-")) {
        ret = datum.substr(8, 2) + "." + datum.substr(5, 2) + "." + datum.substr(0, 4);
    }
    // nicht umkehren, sondern Original zurueckgeben, falls Datum bereits normal ist
    if ((datum.length === 10) && (datum[2] === ".") && (datum[5] === ".")) {
        ret = datum;
    }
    return ret;
}
//# sourceMappingURL=testscripts.js.map